<template>
  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
    <md-card>
      <form v-on:submit.prevent="createSource">
        <md-card-header data-background-color="blue">
          <h4 class="title">Add Website</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <md-field>
                <label>Website URL</label>
                <md-input v-model="source" type="text" name="source" required></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-30">
              <div class="md-layout-item md-size-100">
                <md-button type="button" v-on:click="createSource()" class="md-raised md-success">Add</md-button>
              </div>
            </div>
          </div>
        </md-card-content>
      </form>
    </md-card>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import {API} from '../../services';

    export default {
        name: 'UserSourceList',
        data() {
          return {
            source: ''
          };
        },
        computed: {
            ...mapGetters(["get_sources"]),
        },
        created() {
          this.reloadResources();
        },
        methods: {
          ...mapActions(["SET_SOURCES"]),
          reloadResources() {
            API.getSources().then(
              resp => {
                this.SET_SOURCES(resp.data.data);
              },
            );
          },
          createSource() {
            var sources = this.get_sources;
            API.createSource(this.source).then(
              response => {
                this.reloadResources();
              },
            );
          }
        }
    };
</script>



<!-- function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
} -->